import { Text } from "components/commons";
import { dateFormat, timeFormat } from "utils";
import styles from "../dry-stock.module.scss";
import { prettifyEmployeePosition } from "utils/pretty.utils";
import Big from "big.js";
import { EmployeePosition } from "enums";
import { filter } from "lodash";

export const dryStockDeliveriesMapper = ({ val }) => {
  const { deliveryId, deliveredAt, poReferenceNumber, plateNumber, witnesses } = val;
  let witness = [];
  if (witnesses && witnesses.length > 0) {
    filter(witnesses, (e) => {
      const cashier = e.position === prettifyEmployeePosition(EmployeePosition.CASHIER);
      if (cashier) {
        witness.push(e.name);
      }
      return cashier;
    });
    filter(witnesses, (e) => {
      const crew = e.position !== prettifyEmployeePosition(EmployeePosition.CASHIER);
      if (crew) {
        witness.push(e.name);
      }
      return crew;
    });
  }

  return {
    deliveryId: (
      <>
        <Text className={styles.content}>{deliveryId ?? "0"}</Text>
      </>
    ),
    dateAndTime: (
      <>
        <Text className={styles.content}>{`${dateFormat(deliveredAt)} ${timeFormat(
          deliveredAt,
        )}`}</Text>
      </>
    ),
    poReferenceNumber: (
      <>
        <Text className={styles.content}>{poReferenceNumber ?? ""}</Text>
      </>
    ),
    plateNumber: (
      <>
        <Text className={styles.content}>{plateNumber ?? ""}</Text>
      </>
    ),
    witnesses: (
      <>
        {witness.map((item, i) => (
          <Text className={styles.content}>{item ?? ""}</Text>
        ))}
      </>
    ),
  };
};

export const dryStockDeliveryProductsMapper = ({ val }) => {
  const {
    deliveryId,
    sku,
    product,
    variant,
    poReferenceNumber,
    quantityDelivered,
    quantityAfterReceiving,
    quantityBeforeReceiving,
  } = val;

  const quantityL = Number(Big(quantityAfterReceiving).minus(quantityBeforeReceiving));
  const variance = Number(Big(quantityL).minus(quantityDelivered));
  const quantity = Number(Big(quantityBeforeReceiving).add(quantityDelivered));
  let variancePercentage = 0;
  if (quantity > 0) {
    variancePercentage = Number(Big(variance).div(quantity).mul(100));
  }

  if (variancePercentage > 0) {
    variancePercentage = `(+${variancePercentage.toFixed(2)}%)`;
  } else {
    variancePercentage = `(${variancePercentage.toFixed(2)}%)`;
  }

  return {
    deliveryId: (
      <>
        <Text className={styles.content}>{deliveryId ?? "0"}</Text>
      </>
    ),
    poReferenceNumber: (
      <>
        <Text className={styles.content}>{poReferenceNumber ?? ""}</Text>
      </>
    ),
    itemCode: (
      <>
        <Text className={styles.content}>{sku ?? "-"}</Text>
      </>
    ),
    product: (
      <>
        <Text className={styles.content}>{product ?? "-"}</Text>
      </>
    ),
    variant: (
      <>
        <Text className={styles.content}>{variant ?? "-"}</Text>
      </>
    ),
    beforeReceiving: (
      <>
        <Text className={styles.content}>{quantityBeforeReceiving ?? ""}</Text>
      </>
    ),
    quantityDelivered: (
      <>
        <Text className={styles.content}>{quantityDelivered ?? ""}</Text>
      </>
    ),
    afterReceiving: (
      <>
        <Text className={styles.content}>{quantityAfterReceiving ?? ""}</Text>
      </>
    ),
    variance: (
      <>
        <Text
          className={
            variance > 0 ? styles.positive : variance < 0 ? styles.negative : styles.content
          }
        >
          {variance > 0
            ? `+${variance} ${variancePercentage}`
            : variance < 0
              ? `${variance} ${variancePercentage}`
              : variance}
        </Text>
      </>
    ),
  };
};
